import * as React from "react";
import type { SVGProps } from "react";
const SvgInformationComposition = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#information-composition_svg__a)">
      <path d="M6 14.8a1 1 0 0 1-1-1v-1.2a1 1 0 1 1 2 0v1.2a1 1 0 0 1-1 1ZM5.62 11.12c.12.051.25.078.38.08.13-.002.26-.029.38-.08.121-.05.233-.122.33-.21a1.15 1.15 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.15 1.15 0 0 0-.21-.33 1.15 1.15 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.15 1.15 0 0 0-.33.21 1.15 1.15 0 0 0-.21.33.94.94 0 0 0 0 .76c.05.121.122.233.21.33.097.088.209.16.33.21ZM18 3.27 15.75 5v3.33h1.69V6.64h1.12v1.69h1.69V5L18 3.27ZM15.69 19.66l1.41 1.16a.519.519 0 0 0 .74-.07.53.53 0 0 0 0-.67l-.24-.29.72-.87L19.64 20a.53.53 0 0 0 .74-.07.53.53 0 0 0 0-.67l-1.17-1.43.94-1.15a.64.64 0 0 0-.08-.9.65.65 0 0 0-.9.09l-1 1.14-1.63-.88a.52.52 0 0 0-.65.12.52.52 0 0 0 .11.75l1.31 1.1-.71.86-.34-.18a.52.52 0 0 0-.756.316.528.528 0 0 0 .186.564Z" />
      <path
        fillRule="evenodd"
        d="M10.846 15.538a6 6 0 1 1 0-7.076l1.416-.708A6 6 0 1 1 18.004 12a6.001 6.001 0 0 1 4.239 10.243 6 6 0 0 1-9.98-5.997l-1.417-.708Zm3.82-4.55A6 6 0 0 0 17.993 12a5.996 5.996 0 0 0-4.838 2.462l-1.416-.708a5.996 5.996 0 0 0 .007-3.486l1.423-.712a6 6 0 0 0 1.499 1.433Zm-4.98 2.566a1.002 1.002 0 0 0-.231.462 4 4 0 1 1 .231-.462Zm4.39-6.774c.07.352.187.69.346 1.008l.009.018A3.999 3.999 0 0 0 22 6a4 4 0 1 0-7.923.78ZM18 14a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="information-composition_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInformationComposition;
